import React from 'react'
import { PublicRoute, PublicRouteProps } from '@ppay/client'

import { routes } from '../routes'

export const Public = (props: Omit<PublicRouteProps, 'authorizedPath'>) => (
  <PublicRoute {...props} authorizedPath={routes.dashboard.home} />
)
